import { PRO_TASK_CONSULTATION_TIME_EXT_URL } from "../models/types";
import { _i18n_str } from "../../assets/i18n/non-static-ids";

_i18n_str("PRO_TASK_CONSULTATION_TIME.NOT_REGISTERED");

const EXT_URL = PRO_TASK_CONSULTATION_TIME_EXT_URL;

export const extractConsultationTimeExt = (taskResource: fhir.Task): string => {
  if (!taskResource.hasOwnProperty("extension")) {
    return "NOT_REGISTERED";
  }
  const ext = taskResource.extension.find(
    elem => elem.url === EXT_URL
  ) as fhir.Extension;
  if (ext === undefined) {
    return "NOT_REGISTERED";
  }
  return ext.valueTime;
};



// WEBPACK FOOTER //
// ./src/app/utils/extract-consultation-time-ext.ts